// extracted by mini-css-extract-plugin
export default {"selected":"CallPassTable_selected__e8ojh"};